import {TranslationObject} from '@colonist/i18n'
import {LeaderboardStickyRowData} from '../../../../shared/leaderboard_data/LeaderboardInterfaces'
import {createTDIn, setElementInnerHTML} from '../ui_utils/DomUtils'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {UILeaderboardBaseTableRowView} from './UILeaderboardBaseTableRowView'

export class UILeaderboardTableRowViewUnranked extends UILeaderboardBaseTableRowView {
    readonly customMessage: HTMLTableCellElement

    constructor(container: HTMLElement, rowData: LeaderboardStickyRowData, index: number, onLeaderboardUrlChange: (leaderboardUrl: string) => void) {
        super(container, rowData, index, onLeaderboardUrlChange)

        const tableRowID = rowData.myData ? 'my_leaderboard_cell' : 'leaderboard_cell'

        this.customMessage = createTDIn(this.tableRow, tableRowID)
        this.customMessage.colSpan = 3
        this.customMessage.classList.add('truncate-text')

        this.update(rowData)
    }

    update(rowData: LeaderboardStickyRowData) {
        super.update(rowData)

        if(rowData.unrankedOverrideMessage == undefined) return

        const overrideMessage: TranslationObject = UIUtilsEjsVariables.isUserOnMobileApp ? {key: 'strings:colonistCommon.utils.n/a'} : rowData.unrankedOverrideMessage
        setElementInnerHTML(this.customMessage, overrideMessage)
        this.customMessage.addEventListener('click', (mouseEvent: MouseEvent) => {
            mouseEvent.stopPropagation()
        })
    }
}
